<template>
  <section class="container-md">
    <Article v-for="page in pages" :key="page.path" :page="page" />
  </section>
</template>

<script setup lang="ts">
import type {PageCollectionItemBase} from "@nuxt/content";

const { pages } = defineProps<{
    pages: PageCollectionItemBase[]
}>()
</script>